import { omit } from "lodash";
class ImagePluginService {
  createLoadingData(_, url, componentData) {
    return {
      componentData: {
        ...componentData
      },
      componentState: {
        tempData: url,
        loading: true
      }
    };
  }
  createPluginData(uploadedData, componentData) {
    const { file_name, width, height } = uploadedData.data || {};
    return {
      ...omit(componentData, ["tempData", "loading"]),
      image: { src: { id: file_name }, width, height }
    };
  }
  createErrorData(error, componentData) {
    return {
      ...omit(componentData, ["loading"]),
      error
    };
  }
}
export {
  ImagePluginService
};
//# sourceMappingURL=imagePluginService.js.map
